import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface EmailToggle {
  id: string;
  emailType: string;
  scenarioName: string;
  description: string;
  disabled: boolean;
  hasCustomTemplate?: boolean;
}

export const getEmailTogglesAPI = async () => {
  const response = await baseAPI.get<Array<EmailToggle>>(`/email/toggles`);
  return response.data;
};

export const useGetEmailToggles = () => {
  return useQuery({
    queryKey: [KEYS.EMAIL_TOGGLES],
    queryFn: () => getEmailTogglesAPI(),
  });
};
